import { createStore, applyMiddleware, compose } from 'redux';
import getRuntimeEnv from 'utils/runtimeEnv';
import createRootReducer from './modules/reducer';
import authMiddleware from './modules/auth/middleware';
import bookingMiddleware from './modules/booking/middleware';
import clientMiddleware from './middleware/clientMiddleware';
import dialogMiddleware from './modules/dialog/middleware';
import errorMiddleware from './middleware/errorMiddleware';
import guestMiddleware from './modules/guest/middleware';
import paymentMiddleware from './middleware/paymentMiddleware';
import phoneMiddleware from './modules/phone/middleware';

export default ({ initialState, client }) => {
  const middlewares = [
    clientMiddleware(client),
    authMiddleware,
    bookingMiddleware,
    dialogMiddleware,
    errorMiddleware,
    guestMiddleware,
    paymentMiddleware,
    phoneMiddleware,
  ];

  let finalCreateStore;
  // Build the store for development and test to include of redux dev tools.
  if ((getRuntimeEnv('NODE_ENV') !== 'production' || getRuntimeEnv('STAGING') === 'true') && typeof window !== 'undefined') {
    const composeEnhancers = window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
    finalCreateStore = composeEnhancers(
      applyMiddleware(...middlewares)
    )(createStore);
  }
  else {
    // Build the store for production without redux dev tools
    finalCreateStore = applyMiddleware(...middlewares)(createStore);
  }

  // Redux store
  const store = finalCreateStore(
    createRootReducer(),
    initialState || {},
  );

  return { store };
};
